import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as IconEditBlue } from "../Images/icon_edit_blue.svg";
import { ReactComponent as IconEditWhite } from "../Images/icon_edit_white.svg";
import "../Styles/component.css";
import "../Styles/global.css";

const ApplyBtn = ({ addr }) => {
  const [hover, setHover] = useState(false);
  const navigate = useNavigate();
  return (
    <div
      className="blueBorderBtn"
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={() => navigate(addr)}
    >
      <div style={{ display: "flex" }}>
        {hover ? (
          <IconEditWhite width="20px" height="23px" />
        ) : (
          <IconEditBlue width="20px" height="23px" />
        )}
        <div style={{ height: "23px", width: "59px", marginLeft: "4px" }}>
          등록하기
        </div>
      </div>
    </div>
  );
};

export default ApplyBtn;
